import { useCallback, useMemo, useState } from "react";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import Modal from "@components/modal/modal";
import ModalTitle from "@components/modal/modal-title";

const useInfoModal = (title: string, message: string) => {
  const [memoizedTitle, setTitle] = useState(title);
  const [memoizedMessage, setMessage] = useState(message);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const openModal = useCallback(() => setIsOpen(true), []);

  const InfoDialog = useMemo(
    () => () => (
      <Modal
        open={isOpen}
        onClose={handleClose}
        alignedTop
        className="z-tooltip"
      >
        <div className="p-6 flex flex-col gap-4">
          <ModalTitle onClose={handleClose}>{memoizedTitle}</ModalTitle>
          <div>{memoizedMessage}</div>
          <div className="mt-6 flex items-center gap-2 justify-end">
            <Button
              theme={buttonTheme.default}
              onClick={handleClose}
              text="Close"
            />
          </div>
        </div>
      </Modal>
    ),
    [isOpen, handleClose, memoizedTitle, memoizedMessage],
  );
  return { InfoDialog, openModal, setTitle, setMessage };
};

export default useInfoModal;
